module.exports = __webpack_public_path__ + "img/us.be0d3dd8.svg";